"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToggleSlots = exports.default = exports.Toggle = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _toggleClasses = _interopRequireWildcard(require("./toggleClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getToggleSlots = ownerState => {
  const {
    fullWidth,
    active,
    disabled
  } = ownerState;
  return {
    root: ['root', fullWidth && 'fullWidth', disabled && 'disabled'],
    indicator: ['indicator', active && 'indicatorActive'],
    text: ['text'],
    checkbox: ['checkbox']
  };
};
exports.getToggleSlots = getToggleSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getToggleSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _toggleClasses.getToggleUtilityClass, classes);
  return composedClasses;
};
const ToggleRoot = (0, _material.styled)('label', {
  name: 'MuiOriToggle',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, ownerState.fullWidth && styles.fullWidth]
})(({
  theme,
  ownerState
}) => ({
  display: 'inline-grid',
  gridTemplateColumns: '1fr 1fr',
  justifyItems: 'center',
  alignItems: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  paddingLeft: 15,
  paddingRight: 15,
  borderRadius: 30,
  backgroundColor: theme.palette.grey[100],
  columnGap: theme.spacing(6),
  border: `3px solid ${theme.palette.grey[100]}`,
  cursor: 'pointer',
  ...(ownerState.disabled && {
    cursor: 'inherit'
  }),
  ...(ownerState.fullWidth && {
    width: '100%'
  }),
  [`&.${_toggleClasses.default.disabled} .${_toggleClasses.default.text}`]: {
    color: theme.palette.grey[400]
  }
}));
const Indicator = (0, _material.styled)('div', {
  name: 'MuiOriToggle',
  slot: 'Indicator',
  skipSx: true,
  overridesResolver: ({
    ownerState
  }, styles) => [styles.indicator, ownerState.active && styles.indicatorActive]
})(({
  theme,
  ownerState
}) => ({
  position: 'absolute',
  width: 'calc(50% - 2px)',
  height: 'calc(100% - 4px)',
  top: 2,
  left: 2,
  borderRadius: 30,
  zIndex: 1,
  backgroundColor: theme.palette.common.white,
  transition: theme.transitions.create('transform'),
  ...(ownerState.active && {
    transform: 'translate(100%)'
  }),
  [`&.${_toggleClasses.default.disabled}`]: {
    backgroundColor: theme.palette.action.disabledBackground
  }
}));
const Text = (0, _material.styled)('span', {
  name: 'MuiOriToggle',
  slot: 'Text',
  skipSx: true,
  overridesResolver: ({
    ownerState
  }, styles) => [styles.text]
})(({
  theme,
  ownerState
}) => ({
  display: 'inline-block',
  paddingTop: '0.9rem',
  paddingBottom: '0.9rem',
  height: '3.9rem',
  zIndex: 2,
  margin: 0,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: 1.5,
  fontWeight: 'bold',
  textTransform: 'uppercase',
  transition: theme.transitions.create('color'),
  userSelect: 'none',
  color: theme.palette.text.secondary,
  textAlign: 'center',
  boxSizing: 'border-box',
  width: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  ...(ownerState.isIcon && {
    paddingTop: '0.7rem',
    paddingBottom: '0.7rem'
  }),
  ...(ownerState.active && {
    color: theme.palette.text.primary
  })
}));
const Checkbox = (0, _material.styled)('input', {
  name: 'MuiOriToggle',
  slot: 'Checkbox',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.checkbox]
})({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1
});
const Toggle = exports.Toggle = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriToggle'
  });
  const {
    id,
    firstIcon,
    secondIcon,
    firstText,
    secondText,
    checked,
    onChange,
    defaultChecked,
    fullWidth,
    className,
    disabled,
    component,
    ...rest
  } = props;
  const {
    current: controlled
  } = (0, _react.useRef)(checked != null);
  const [value, setValue] = (0, _react.useState)(Boolean(defaultChecked ?? checked));
  const isFirstIcon = (0, _react.useMemo)(() => typeof firstIcon !== 'undefined', [firstIcon]);
  const isSecondIcon = (0, _react.useMemo)(() => typeof secondIcon !== 'undefined', [secondIcon]);
  const ownerState = {
    ...props,
    disabled,
    active: value,
    fullWidth,
    isIcon: false
  };
  const classes = useUtilityClasses(ownerState);
  (0, _react.useEffect)(() => {
    if (typeof checked === 'boolean') {
      setValue(checked);
    }
  }, [checked]);
  const handleChange = (0, _react.useCallback)(event => {
    onChange?.(event);
    if (!controlled) {
      setValue(event.currentTarget.checked);
    }
  }, [onChange, controlled]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ToggleRoot, {
    ref: ref,
    className: (0, _clsx.default)(classes.root, className),
    ownerState: ownerState,
    htmlFor: id,
    ...rest,
    as: component,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Indicator, {
      ownerState: ownerState,
      className: classes.indicator
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Text, {
      ownerState: {
        ...ownerState,
        active: !value,
        isIcon: isFirstIcon
      },
      className: (0, _clsx.default)(classes.text, isFirstIcon && _toggleClasses.default.icon, !value && _toggleClasses.default.textActive),
      "data-text": firstText,
      children: isFirstIcon ? firstIcon : firstText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Text, {
      ownerState: {
        ...ownerState,
        isIcon: isSecondIcon
      },
      className: (0, _clsx.default)(classes.text, isSecondIcon && _toggleClasses.default.icon, value && _toggleClasses.default.textActive),
      "data-text": secondText,
      children: isSecondIcon ? secondIcon : secondText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Checkbox, {
      id: id,
      ownerState: ownerState,
      className: classes.checkbox,
      type: "checkbox",
      checked: value,
      disabled: disabled,
      onChange: handleChange
    })]
  });
});
var _default = exports.default = Toggle;
//# sourceMappingURL=Toggle.js.map